import { numSteps } from '../../builder-selection';
import { currentBuilderState } from '../builder.state';

export function changeStep(step: number): void {
    const state = currentBuilderState();

    state.step = step;
    state.atFinalStep = state.step === numSteps;
}

export function nextStep(): void {
    const state = currentBuilderState();

    changeStep(Math.min(state.step + 1, numSteps));
}
